import React from 'react';
import TextCell from './TextCell';

const BooleanCell = ({
  value, trueText = 'Yes', falseText = 'No', unknownText = ' ', ...props
}) => (
  <TextCell {...props}>
    {value == null ? unknownText : value ? trueText : falseText}
  </TextCell>
);

export default BooleanCell;
